import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Card } from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import TableGeneric from "../../compartidos/abms/TableGeneric";
import BuscadorAbm from "../../compartidos/abms/BuscadorAbm";
import { guardarCategoriaFormulario, getCategoriasFormularios, eliminarCategoriaFormulario } from "../../../actions/miOspedyc/abmCategoriasFormularios";
import LoadingBeforeViewData from "../../compartidos/LoadingBeforeViewData";
import { FormCategoriaFormulario } from "./FormCategoriaFormulario";
import EditButtonAbm from "../../compartidos/abms/EditButtonAbm";
import AddButtonAbm from "../../compartidos/abms/AddButtonAbm";
import DeleteButtonAbm from "../../compartidos/abms/DeleteButtonAbm";

const useStyles = makeStyles({
    root: {
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "1rem"
    }
});

const CategoriasScreen = () => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const { categoriasFormularios } = useSelector((state) => state.formulariosMiOspedyc);

    const handleSearch = (textoBuscado) => {
        dispatch(getCategoriasFormularios(textoBuscado));
    }

    const handleSave = (formValues, handleClose) => {
        dispatch(guardarCategoriaFormulario(null, formValues, handleClose));
    }

    const handleEdit = (formValues, handleClose) => {
        dispatch(guardarCategoriaFormulario(formValues.idCategoriaFormularios, formValues, handleClose));
    }

    const handleDelete = (idCategoriaFormularios) => {
        dispatch(eliminarCategoriaFormulario(idCategoriaFormularios))
    }

    useEffect(() => {
        dispatch(getCategoriasFormularios());
    }, [dispatch])


    if (categoriasFormularios === null) {
        return <LoadingBeforeViewData />
    }

    return (
        <div>
            <Grid container justify="center">
                <Grid item xs={12} md={6} className={classes.root}>
                    <BuscadorAbm title="Buscar Categorias" handleSearch={handleSearch} />
                </Grid>
                <Grid item xs={12} md={9} style={{ textAlign: 'right', marginTop: "2rem" }}>
                    <AddButtonAbm
                        title="Agregar Categoria"
                        form={FormCategoriaFormulario}
                        handleSave={handleSave}
                        permiso={null}
                    />
                </Grid>

                <Grid item xs={12} md={9} style={{ marginTop: "2rem" }}>
                    <Card>
                        <TableGeneric
                            data={categoriasFormularios}
                            columns={[
                                {
                                    label: "",
                                    customBody: (item) => (
                                        <>
                                            <EditButtonAbm
                                                form={FormCategoriaFormulario}
                                                item={item}
                                                handleSave={handleEdit}
                                            />

                                            <DeleteButtonAbm
                                                handleDelete={() => handleDelete(item.idCategoriaFormularios)}
                                                permiso={null}
                                            />
                                        </>
                                    )
                                },
                                {
                                    label: "ID",
                                    id: "idCategoriaFormularios",
                                    sort: true
                                },
                                {
                                    label: "Descripcion",
                                    id: "descripcion",
                                    sort: true
                                },
                            ]}
                        />
                    </Card>
                </Grid>
            </Grid>
        </div>
    );

};

export default CategoriasScreen;